module.exports = __webpack_public_path__ + "static/media/menu_open-white-48dp.12786739.svg";